import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IframeResizer from 'iframe-resizer-react';
class LawdocsIframe extends React.Component {
    constructor(props) {
        super(props);
        this.onInit = () => {
            this.iframeEl = document.getElementById(this.iframeId);
            window.addEventListener('message', this.onMessage);
            this.iframeEl.contentWindow.postMessage('SYN', '*');
        };
        this.onMessage = (message) => {
            if (message.origin === window.location.origin)
                return;
            if (message.data && message.data === 'ACK') {
                this.channelReady = true;
                while (this.queue.length > 0) {
                    this.iframeEl.contentWindow.postMessage(this.queue.shift(), '*');
                }
            }
            if (message.data && message.data.event) {
                this.observers.forEach((observer) => observer.apply(null, [message.data.event.toUpperCase(), message.data.parameters]));
            }
        };
        this.sendMessage = (message) => {
            if (this.channelReady) {
                this.iframeEl.contentWindow.postMessage(message, '*');
            }
            else {
                this.queue.push(message);
            }
        };
        this.addSetting = (id, value) => {
            this.sendMessage({
                method: 'ADD_SETTING',
                parameters: { id, value }
            });
        };
        this.addTranslations = (translations) => {
            this.sendMessage({
                method: 'ADD_TRANSLATIONS',
                parameters: { translations }
            });
        };
        // MUST trigger observers in iframe
        this.notifyObservers = (event, ...parameters) => {
            this.sendMessage({
                event: event,
                parameters: parameters
            });
        };
        this.addObserver = (func) => {
            this.observers.push(func);
            return () => {
                this.observers.forEach((observer, index) => {
                    if (observer === func) {
                        this.observers.splice(index, 1);
                    }
                });
            };
        };
        this.iframeRef = React.createRef();
        this.observers = [];
        this.channelReady = false;
        this.queue = [];
        this.iframeId = 'lawdocs-iframe';
        this.iframeEl = null;
        this.iframeSrc = `${props.endpoint}/flow/${props.type}`;
        const urlSearchParams = new URLSearchParams(window.location.search);
        const documentId = urlSearchParams.get('id');
        if (documentId) {
            this.iframeSrc += `?id=${documentId}`;
        }
    }
    componentDidMount() {
        // this component is now the replacement for the LawDocs api
        // other components (LawdocsSaveButton ...) depend on LawDocs being available on window
        window.LawDocs = this;
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.onMessage, false);
    }
    render() {
        return (_jsx(IframeResizer, { forwardRef: this.iframeRef, src: this.iframeSrc, id: this.iframeId, style: { width: '1px', minWidth: '100%' }, onInit: this.onInit, checkOrigin: false, heightCalculationMethod: 'taggedElement', resizeFrom: 'child', scrolling: false, autoResize: true }));
    }
}
LawdocsIframe.propTypes = { type: PropTypes.string.isRequired };
export default LawdocsIframe;
